export default "__VITE_ASSET__BtdGG123__"